<template>
  <app-panel class="oracle-events-panel">
    <paginated-content
      v-model:limit="pageLimit"
      :entities="oracleEvents"
      pagination-style="history"
      @prev-clicked="loadPrevEvents"
      @next-clicked="loadNextEvents">
      <oracle-events-table
        :oracle-events="oracleEvents"
        class="oracle-events-panel__table"/>
    </paginated-content>
  </app-panel>
</template>

<script setup>
const { oracleEvents } = storeToRefs(useOracleDetailsStore())
const { fetchOracleEvents } = useOracleDetailsStore()

const route = useRoute()

const pageLimit = usePageLimit('oracle-events')

watch(pageLimit, () => {
  fetchOracleEvents({ id: route.params.id, limit: pageLimit.value })
})

function loadPrevEvents() {
  fetchOracleEvents({ queryParameters: oracleEvents.value.prev })
}

function loadNextEvents() {
  fetchOracleEvents({ queryParameters: oracleEvents.value.next })
}

if (import.meta.client) {
  fetchOracleEvents({ id: route.params.id, limit: pageLimit.value })
}
</script>

<style scoped>
.oracle-events-panel__table {
  margin-bottom: var(--space-4);
}
</style>
